// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#entry-name[data-v-a3b94330] {\n  max-width: 200px;\n}\n[data-v-a3b94330] .disabled {\n  cursor: not-allowed;\n}\n[data-v-a3b94330] .modal-footer > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin: 0;\n}\n.success-icon svg[data-v-a3b94330] {\n  font-size: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
